import React from 'react'

class Ambilight extends React.Component {

  constructor(props) {
    super(props)
  }

  render() {
    return (
      <div className="Ambilight">
        <div className="Ambilight-Left"> </div>
        <div className="Ambilight-Right"> </div>
      </div>
    )
  }
}

export default Ambilight


// WEBPACK FOOTER //
// ./src/components/Ambilight.js